// removed by extract-text-webpack-plugin
module.exports = {"slidesContainer":"_2k5cFHwVOqTU_w9l1k_IRm","slideThumbnail":"_2YASbDE8lfu_v2UlHvCo0h"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Slide/Slide.css
// module id = 364
// module chunks = 0